import { FailedPage } from '@/components/FailedPage';

import { useAppDispatch } from '@/hooks/redux';

import { signOut } from '@/redux/auth/actions';

export function ThirdPartyComplianceCheckFailedPage() {
  const dispatch = useAppDispatch();
  const onBackToSignIn = () => dispatch(signOut());

  return (
    <FailedPage
      translationPrefix="thirdPartyComplianceCheckFailed"
      onAction={onBackToSignIn}
      testIdPrefix="third-party-validation-check-failed-page"
    />
  );
}

export default ThirdPartyComplianceCheckFailedPage;
